import { render, staticRenderFns } from "./left-nav.vue?vue&type=template&id=8322f732&"
import script from "./left-nav.vue?vue&type=script&lang=ts&"
export * from "./left-nav.vue?vue&type=script&lang=ts&"
import style0 from "./left-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports